<div class="picklist-holder">
  <div class="picklist-center">
    <app-picklist [secondSelectorActive]="false"
                  [firstLabelName]="firstLabelName"
                  [firstSelectorList]="userIds"
                  (firstSelectorResults)="userSelectorValue($event)"
                  [currentAssigned]="assignedList"
                  [currentAvailable]="availableList"
                  (formResults)="pickListFormResults($event)"
    >
    </app-picklist>
  </div>
</div>
